import _ from 'lodash'
import $ from 'jquery'
import { isEmpty } from '~/statics/validators.js'
import clipboardUtils, { store as clipboardStore } from './grid.utils.clipboard'

export const clipboard = {
  store: clipboardStore,
  config: clipboardUtils
}

export const execute = d => (...args) => (_.isFunction(d)
  ? d.call(this, Array.from(args))
  : d)
export const cloneStructure = (source, deep) => {
  const getKeys = source => source != null
    ? Object.keys(source)
    : []
  const cloneProperty = (sourceValue, deep) => (_.isPlainObject(sourceValue) && deep === true)
    ? cloneStructure(sourceValue, deep)
    : null

  return getKeys(source)
    .map(key => ({ key, value: cloneProperty(source[key], deep) }))
    .reduce((target, item) => ({ ...target, [item.key]: item.value }), {})
}
export const isEmptyObject = source => {
  const getKeys = source => source != null
    ? Object.keys(source)
    : []
  const isEmptyProperty = (sourceValue) => _.isPlainObject(sourceValue)
    ? isEmptyObject(sourceValue)
    : isEmpty(sourceValue)

  return getKeys(source)
    .map(key => ({ key, isEmpty: isEmptyProperty(source[key]) }))
    .filter(prop => !prop.isEmpty).length > 0
}
export const getScrollBarWidth = () => {
  const $outer = $('<div>')
    .css({ visibility: 'hidden', width: 100, overflow: 'scroll' })
    .appendTo('body')

  const widthWithScroll = $('<div>')
    .css({ width: '100%' })
    .appendTo($outer)
    .outerWidth()

  $outer.remove()

  return 100 - widthWithScroll
}

export const events = {
  list: [],
  add(element, event, func) {
    this.list.push({ element, event, func })
    element.addEventListener(event, func)
  },
  remove(element, event, func) {
    this.list
      .filter(
        (x) => x.element === element && x.event === event && x.func === func
      )
      .forEach((item) => {
        element.removeEventListener(item.event, item.func)
      })
  },
  clear(element, event) {
    this.list
      .filter((x) => x.element === element && x.event === event)
      .forEach((item) => {
        element.removeEventListener(item.event, item.func)
      })
  },
  replace(element, event, func) {
    this.clear(element, event)
    this.add(element, event, func)
  }
}
